import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import Enums from '../../helpers/enums';
import { CartType } from '../../types/CartType';

export interface CartState {
  cartItems: CartType[];
  signupBonusItem: any; // Refine this type if possible
  isDelivery: boolean;
  cartUUId: string | null;
}

// Define the initial state using the CartState interface
const initialState: CartState = {
  cartItems: [],
  signupBonusItem: {}, // Use a more specific type if known
  isDelivery: false,
  cartUUId: null
};

export const cartReducer = createSlice({
  name: 'cartReducer',
  initialState,
  reducers: {
    addToCart: (state, action: PayloadAction<CartType>) => {
      const payload = { ...action.payload, orderDateTime: new Date() };
      const updatedCartItems = [...state.cartItems, payload];
      state.cartItems = updatedCartItems;
    },

    updateToCart: (state, action: PayloadAction<CartType>) => {
      const existingItemIndex = state.cartItems.findIndex(item => item._id === action.payload._id);

      if (existingItemIndex !== -1) {
        const updatedCartItem = { ...action.payload };

        if (updatedCartItem.type === Enums.comboType.quickCombo) {
          updatedCartItem.items?.forEach((comboData) => {
            const foundComboItem = action.payload.items?.find(comboItem => comboItem.salesItemId === comboData.posItemId);
            if (foundComboItem) {
              return {
                ...comboData,
                customizations: [...foundComboItem.customizations],
              };
            }
            return comboData;
          });
          state.cartItems[existingItemIndex] = updatedCartItem;
        } else {
          state.cartItems[existingItemIndex] = updatedCartItem;
        }
      }
    },

    removeFromCart: (state, action: PayloadAction<{}>) => {
      const removedItemId = action.payload;
      state.cartItems = state.cartItems.filter(item => item._id !== removedItemId);
    },

    clearCart: (state) => {
      state.cartItems = [];
      state.cartUUId = null;
    },

    setSignupBonus: (state, action: PayloadAction<any>) => { // Use a specific type
      state.signupBonusItem = action.payload;
    },

    removeFreeItem: (state, action: PayloadAction<number | undefined>) => {
      if (typeof action.payload === 'number') {
        state.cartItems.splice(action.payload, 1);
      } else {
        state.cartItems = state.cartItems.filter(item => !item.isFree);
      }
    },

    setIsDelivery: (state, action: PayloadAction<boolean>) => {
      state.isDelivery = action.payload;
    },

    setCartUUId: (state, action: PayloadAction<string | null>) => {
      state.cartUUId = action.payload;
    },
  }
});

export default cartReducer;

export const {
  addToCart,
  updateToCart,
  removeFromCart,
  clearCart,
  setSignupBonus,
  removeFreeItem,
  setIsDelivery,
  setCartUUId
} = cartReducer.actions;
